import { DzbFieldTypes } from 'dzb/inquiry/fields';

export const dzbSteps: Record<keyof DzbFieldTypes, string> = {
  companyDataPage: 'companyDataPage',
  retailerDataPage: 'retailerDataPage',
  personalDataPage: 'personalDataPage',
} as const;
